import { DEFAULT_ZOOM } from '../../constants';
import type {
  IGoogleMapsImperativeActions,
  Location,
  PinIconInterface,
  PinSymbolInterface,
} from '../../GoogleMap.types';
import { createSdkMethods } from './sdkMethods';

export const createImperativeMethods = (
  mapRef: React.MutableRefObject<google.maps.Map | null>,
  updateZoom: (zoom: number) => void,
  updateCenter: (center: google.maps.LatLngLiteral) => void,
  locations: Array<Location>,
): IGoogleMapsImperativeActions => {
  const sdkMethods = createSdkMethods(mapRef, updateZoom, updateCenter);

  return {
    setMapCenter: (longitude: number, latitude: number) => {
      return sdkMethods.setMapCenter(longitude, latitude);
    },
    setMapZoom: (zoom: number) => {
      return sdkMethods.setMapZoom(zoom);
    },
    fitBounds: (bounds: {
      north: number;
      south: number;
      east: number;
      west: number;
    }) => {
      return sdkMethods.fitBounds(bounds);
    },
    setMarkers: (newLocations: Array<Location>) => {
      return sdkMethods.setMarkers(newLocations);
    },
    setMarkerIcon: (updateData: {
      coordinates: {
        latitude: Location['latitude'];
        longitude: Location['longitude'];
      };
      iconOptions: PinIconInterface | PinSymbolInterface;
      locations: Array<Location>;
    }) => {
      return sdkMethods.setMarkerIcon(updateData);
    },
    getVisibleMarkers: () => {
      return sdkMethods.getVisibleMarkers(locations);
    },
    getCenter: () => {
      if (mapRef.current && mapRef.current.getCenter) {
        const center = mapRef.current.getCenter();
        if (center) {
          return {
            lat: () => center.lat(),
            lng: () => center.lng(),
          };
        }
      }
      // Return default center if map not initialized
      return {
        lat: () => 0,
        lng: () => 0,
      };
    },
    getZoom: () => {
      if (mapRef.current && mapRef.current.getZoom) {
        const zoom = mapRef.current.getZoom();
        return zoom !== undefined ? zoom : DEFAULT_ZOOM;
      }
      return DEFAULT_ZOOM; // Legacy fallback
    },
  };
};
